import { TrailSearchResult } from '@alltrails/search/types/algoliaResultTypes';

const convertResultsAndCreateLookup = (initialResults?: TrailSearchResult[]) => {
  if (!initialResults) {
    return { convertedResults: [], lookupTable: {} };
  }
  const filteredResults = initialResults?.filter?.(result => result._geoloc !== undefined);
  const convertedResults: any[] = [];
  const lookupTable: Record<string, any> = {};

  filteredResults?.forEach?.(result => {
    if (result._geoloc) {
      const convertedResult = {
        _geoloc: result._geoloc,
        _cluster_geoloc: result?._cluster_geoloc,
        ID: String(result.ID) || String(result.id),
        type: result.type
      };

      if (convertedResult) {
        convertedResults.push(convertedResult);
        lookupTable[convertedResult.ID] = result;
      }
    }
  });

  return { convertedResults, lookupTable };
};

export default convertResultsAndCreateLookup;
